if (!customElements.get("td-quantity-sq-ft")) {
  class TdQuantitySqFt extends HTMLElement {
    constructor() {
      super();
      this.sqFtInput = null;
      this.boxesInput = null;
      this.squareFootage = 0;
      this.selectedOverage = 0;
      this.totalBoxesElement = null;
      this.hitOverageLimit = false;
    }

    initializeValues() {
      if (this.sqFtInput) {
        this.sqFtInput.value = 1;
      }
    
      if (this.boxesInput) {
        this.boxesInput.value = 1;
      }
    
      if (this.standardInput) {
        this.standardInput.value = 1; 
      }
    
      this.dispatchUpdatedBoxes();
    }
    
    connectedCallback() {
      this.sqFtInput = this.querySelector("[data-input-sq-ft]");
      this.boxesInput = this.querySelector("[data-input-boxes]");
      this.standardInput = this.querySelector("[data-input-standard]");
    
      this.squareFootage = parseFloat(this.dataset.squareFootage) || 0;
      this.selectedOverage = parseFloat(this.dataset.defaultOverage) || 0;
      this.totalBoxesElement = this.querySelector("[data-total-boxes]");
      this.groutQuantityPerBox = parseFloat(this.dataset.groutQuantity) || 0;
      this.overageLimit = parseFloat(this.dataset.overageLimit) || 0;
      this.overageWarning = document.querySelector("[data-overage-warning]");
      this.quantityUnit = this.getAttribute("data-quantity-unit");

      this.initializeValues();
    
      if (this.sqFtInput && this.boxesInput) {
        this.sqFtInput.addEventListener("input", this.updateBoxes.bind(this));
        this.boxesInput.addEventListener("input", this.updateSqFt.bind(this));
      } else if (this.standardInput) {
        this.standardInput.addEventListener("input", this.updateStandard.bind(this));
      }
    
      this.querySelectorAll(".td-qsf__overage-button").forEach(button => {
        button.addEventListener("click", this.handleOverageSelection.bind(this));
      });
    
      this.selectDefaultOverage();
    }
    

    updateBoxes() {
      const sqFtValue = parseFloat(this.sqFtInput.value) || 0;
      const boxes = Math.ceil(sqFtValue / this.squareFootage);
      this.boxesInput.value = boxes;
      this.dispatchUpdatedBoxes();
    }

    updateSqFt() {
      const boxesValue = parseInt(this.boxesInput.value) || 0;
      const sqFt = boxesValue * this.squareFootage;
      this.sqFtInput.value = sqFt.toFixed(2);
      this.dispatchUpdatedBoxes();
    }

    updateStandard() {
      const standardValue = parseInt(this.standardInput.value) || 0;
    
      if (this.totalBoxesElement) {
        this.totalBoxesElement.textContent = standardValue;
        this.totalBoxesElement.setAttribute("data-total-boxes", standardValue);
      }
    
      const totalGroutBags = Math.ceil(standardValue * this.groutQuantityPerBox);
      const groutElement = document.querySelector(".td-product__grout-qty");
      if (groutElement) {
        groutElement.textContent = `${totalGroutBags} Bag${totalGroutBags > 1 ? 's' : ''} of`;
      }
    
      const groutPricePerBag = parseFloat(this.dataset.groutPrice) || 0;
      const totalGroutPrice = totalGroutBags * groutPricePerBag / 100;
    
      const groutPriceElement = document.querySelector(".td-product__grout-price");
      if (groutPriceElement) {
        groutPriceElement.textContent = `($${totalGroutPrice.toFixed(2)})`;
      }
    
      this.dispatchUpdatedBoxes();

      this.dispatchEvent(
        new CustomEvent("total-boxes-updated", {
          detail: { totalBoxes: standardValue, groutQuantity: totalGroutBags, groutPrice: totalGroutPrice },
          bubbles: true,
        })
      );
    }
    


    handleOverageSelection(event) {
      event.preventDefault();
    
      const button = event.currentTarget;
      this.selectedOverage = parseFloat(button.dataset.overage) || 0;
    
      if (this.selectedOverage < this.overageLimit) {
        this.hitOverageLimit = true;
      } else {
        this.hitOverageLimit = false;
      }

      this.querySelectorAll(".td-qsf__overage-button").forEach(btn => {
        btn.classList.remove("active");
      });
      button.classList.add("active");
    
      this.dispatchUpdatedBoxes();
    }
    

    selectDefaultOverage() {
      const defaultButton = this.querySelector(
        `.td-qsf__overage-button[data-overage="${this.selectedOverage}"]`
      );

      if (this.selectedOverage < this.overageLimit) {
        this.hitOverageLimit = true;
      } else {
        this.hitOverageLimit = false;
      }


      if (defaultButton) {
        defaultButton.classList.add("active");
        this.dispatchUpdatedBoxes();
      }
    }

    dispatchUpdatedBoxes() {
      let boxesValue = 0;
    

      if (this.boxesInput) {
        // Use square footage for overage total boxes calcuation 
        this.totalBoxes = Math.ceil((this.sqFtInput.value * (1 + this.selectedOverage / 100)) / this.squareFootage);
      } else if (this.standardInput) {
        boxesValue = parseInt(this.standardInput.value) || 0;
        this.totalBoxes = Math.ceil(boxesValue * (1 + this.selectedOverage / 100));
      }
    
    

      if (this.totalBoxesElement) {
        let totalBoxesText = this.totalBoxes;
      
        if (this.quantityUnit) {
          if (this.quantityUnit === "2-pack") {

            totalBoxesText = (totalBoxesText *= 2) + (totalBoxesText === 1 ? " box" : " boxes");
          } else if (this.quantityUnit === "box") {
            totalBoxesText += this.totalBoxes === 1 ? " box" : " boxes";
          } else if (this.quantityUnit === "piece") {
            totalBoxesText += this.totalBoxes === 1 ? " piece" : " pieces";
          } else {
            totalBoxesText += ` ${this.quantityUnit}`;
          }
        }
      
        this.totalBoxesElement.setAttribute("data-total-boxes", totalBoxesText);
        this.totalBoxesElement.textContent = totalBoxesText;
      }
      

      const totalGroutBags = Math.ceil(this.totalBoxes * this.groutQuantityPerBox);
    
      const groutElement = document.querySelector(".td-product__grout-qty");
      if (groutElement) {
        groutElement.textContent = `${totalGroutBags} Bag${totalGroutBags != 1 ? 's' : ''} of`;
      }
    
      const groutPricePerBag = parseFloat(this.dataset.groutPrice) || 0;
      const totalGroutPrice = totalGroutBags * groutPricePerBag / 100;
    
      const groutPriceElement = document.querySelector(".td-product__grout-price");
      if (groutPriceElement) {
        groutPriceElement.textContent = `($${totalGroutPrice.toFixed(2)})`;
      }

      this.dispatchEvent(
        new CustomEvent("total-boxes-updated", {
          detail: { totalBoxes: this.totalBoxes, groutQuantity: totalGroutBags, groutPrice: totalGroutPrice, overageLimit: this.hitOverageLimit },
          bubbles: true
        })
      );
    }
    
    
  }

  customElements.define("td-quantity-sq-ft", TdQuantitySqFt);
}
